import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AuthService } from 'src/app/core-services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ElementRef } from '@angular/core';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';

@Component({
  selector: 'app-api-list',
  templateUrl: './api-list.component.html',
  styleUrls: ['./api-list.component.scss']
})
export class APIListComponent implements OnInit {
  APIData: any;
  totalcount: number = 0;
  apiName: string;
  date: string = '';
  pageNo: number;
  pageSize: number;
  selectedDate: any = '';
  data: any;
  toDayDate: Date;
  rageYears: string;

  constructor(private toastr: ToastrService,
    private adminService: AdminService, private authenticationService: AuthService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.pageNo = 1;
    this.pageSize = 10;
    this.toDayDate = new Date();
    this.rageYears = this.toDayDate.getUTCFullYear() + ':' + (this.toDayDate.getUTCFullYear() + 50);
    this.getAPIList();
  }

  getAPIList() {
    if (this.selectedDate != undefined && this.selectedDate == null && this.selectedDate != '') {
      // this.selectedDate = new Date();
      this.date = this.dateConvert(this.selectedDate);
    }
    //  this.date = this.dateConvert(this.selectedDate);

    if (this.apiName == undefined || this.apiName == null) this.apiName = "";

    if (this.pageNo > 0 && this.pageSize > 0) {
      this.spinner.show();
      this.adminService.GetAPIList(this.apiName, this.date, this.pageNo, this.pageSize).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.data = response.content;
          this.APIData = response.content.contents;
          if (response.content.contents.length > 0) {
            response.content.contents.forEach(element => {
              if (element != null) {
                element.createdDate = this.dateConvertNew(element.createdDate)
              }
            });
          }
          this.totalcount = response.content.totalCount;
          this.spinner.hide();
        }
        this.spinner.hide();
      })
    }
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");

  }

  toDateChange() {
    let date = new Date(this.selectedDate).toDateString();
    this.date = this.dateConvert(date);

    this.getAPIList();
  }

  paginate(event) {
    this.pageNo = event.page + 1;
    this.pageSize = event.rows;
    this.getAPIList();
  }

  filterSearch(searchText) {
    this.pageNo = 1;
    this.pageSize = 10;
    this.apiName = searchText;
    this.getAPIList();
  }


  dateConvertNew(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
  }

  exportToCSV(date) {
    if (date != null && date != '' && date != undefined) {      
      var dateData = date.split('-'); ''
      let date1 = '';
      if (dateData != null && dateData.length > 0 && dateData.length == 3) {
        date1 = dateData[2] + '-' + dateData[1] + '-' + dateData[0]
      }
      this.spinner.show();
      this.adminService.GetFeelMonApiByCreatedDate(date1).subscribe((response: any) => {
        if (response != null && response.content != null && response.content.length > 0) {
          response.content.forEach(element => {
            if (element != null) {
              if (element.nextPortName == null || element.nextPortName == '') {
                element.nextPortName = '';
                element.nextPortLocode = '';
                element.nextPortEtaCalc = '';
                element.nextPortTravelDistanceNm = '';
                element.nextPortTravelTimeH = '';
              }
            }
          });
          this.downloadCsvFile(response.content, date);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          this.toastr.error('Records not found', 'Error')
        }
      });
    }
  }

  downloadCsvFile(data, date) {
    let csvHeader = ['Sr.No', 'VesselsId', 'ImoNumber', 'MmsiNumber', 'VesselsName', 'LastPortAta', 'LastPortAtd', 'LastPortCode', 'LastPortName', 'NextPortEtaCalc', 'NextPortCode', 'NextPortName', 'NextPortTravelDistanceNm', 'NextPortTravelTimeH', 'CourseOverGround', 'Latitude', 'LocationStr', 'Longitude', 'NavStatus', 'Received', 'Speed', 'TrueHeading', 'Destination', 'Draught', 'VoyageEta', 'VoyageReceived'];
    let csvTitle = 'FleetMon API Detail_' + date;

    let csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: csvTitle,
      useBom: true,
      noDownload: false,
      headers: csvHeader
    };
    var data1 = new AngularCsv(data, csvTitle, csvOptions);

  }

  // ConvertToCSV(objArray, headerList) {
  //   let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  //   let str = '';
  //   let row = 'S.No,';
  //   for (let index in headerList) {
  //    row += headerList[index] + ',';
  //   }
  //   row = row.slice(0, -1);
  //   str += row + '\r\n';
  //   for (let i = 0; i < array.length; i++) {
  //    let line = (i+1)+'';
  //    for (let index in headerList) {
  //     let head = headerList[index];
  //     line += ',' + array[i][head];
  //    }
  //    str += line + '\r\n';
  //   }
  //   return str;
  //  }



  // ConvertToCSV(objArray, headerList, filename) {
  //   let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  //   let str = '';
  //   let row = 'Sr.No,';

  //   for (let index in headerList) {
  //     row += headerList[index] + ',';
  //   }

  //   row = row.slice(0, -1);
  //   str += row + '\r\n';
  //   for (let i = 0; i < array.length; i++) {
  //     let line = (i + 1) + '';
  //     for (let index in headerList) {
  //       let head = headerList[index];
  //       // line += ',' + array[i].head;
  //       let line1 = this.getValues(array[i], head);
  //       if (line1 != '') {
  //         line += ',' + line1;
  //       }
  //     }
  //     str += line + '\r\n';
  //   }
  //   return str;
  // }

}